export default __webpack_public_path__ + "static/media/m1.dcb079b6.jpg";